import React, { Fragment, useEffect, useState } from "react";
import "./login-69cd7.css";
import "./style.bundle9cd7.css";
import { Link, useNavigate } from "react-router-dom";
import { logindata } from "../../services/login";
import { toast } from "react-toastify";
export const Login = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [ltype, setLType] = useState("");
  function submitlogin(e) {
    e.preventDefault();
    setSubmitted(true);
    setErrorMsg("")
    if(user !== "" && pass !== ""){
      const temp=new FormData();
      temp.append("email",user);
      temp.append("password",pass);
      logindata(temp).then((res)=>{
        if(res.status===true){
          localStorage.setItem("Role",res.role);
          localStorage.setItem("Name",res.name);
          localStorage.setItem("UID",res.id);
          navigate("/dashboard");
        }else{
          setErrorMsg(res.message)
        }
      })
    }
  }
  useEffect(() => {
    var url = window.location.href.split("/#/");
    setLType(url[1]);
  }, []);

  function loginroute() {
    if (ltype === "athletelogin") {
      navigate("/athleteregister");
    } else if (ltype === "coachlogin") {
      navigate("/coachregister");
    } else if (ltype === "centerheadlogin") {
      navigate("/centerheadregister");
    }
  }
  return (
    <Fragment>
      <div style={{backgroundImage: `url(${require("../../assets/img/bground.jfif")})`,backgroundSize: "cover",}}>
      <div className="d-flex flex-column flex-root" >
        <div
          className="login login-6 login-signin-on login-signin-on d-flex flex-column-fluid"
          id="kt_login"
        >
          <div
            className="d-flex flex-column flex-lg-row flex-row-fluid text-center"
            // style="background-image: url(assets/media/bg/bg-3.jpg);"
          >
          
            <div className=" d-flex w-100 flex-center p-15 position-relative overflow-hidden">
              <div className="card login-wrapper">
                <div className="login-signin">
                  <div className="text-center mb-10 mb-lg-20">
                    <h2 className="font-weight-bold mt-2">Member Login</h2>
                  </div>
                  <div className="form-group pl-2 pr-2">
                    <input
                      className="form-control"
                      type="text"
                      value={user}
                      onChange={(e) => setUser(e.target.value)}
                      placeholder="Username"
                      autoComplete="off"
                    />
                    {submitted && !user && (
                      <span className="text-danger">Username is required</span>
                    )}
                  </div>
                  <div className="form-group pl-2 pr-2">
                    <input
                      className="form-control"
                      type="Password"
                      value={pass}
                      maxLength={12}
                      onChange={(e) => setPass(e.target.value)}
                      placeholder="Password"
                      name="password"
                    />
                    {submitted && !pass && (
                      <span className="text-danger">Password is required</span>
                    )}
                  </div>
                  {errorMsg !== "" && (
                    <span className="text-danger">{errorMsg}</span>
                  )}

                  <div className="text-center mt-15">
                    <button
                      className="btn btn-primary btn-sm py-4 px-9 font-weight-bold mb-3"
                      onClick={submitlogin}
                    >
                      Sign In
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    
    </Fragment>
  );
};
